import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { WebServicesService } from "../webservices.service";
import { GenericFile } from "src/app/_models/models";

export class DocDownloadApiService{
    constructor(private _ws: WebServicesService) {}

    getGenerated(id: number): Observable<GenericFile> {
        const url = `${environment.wsBaseUrl}/api/DocDownload/DocGenerated/${encodeURIComponent(id)}`;
        return this._ws.getWithoutCache(url);
    }

    getPicking(date: string, days: number): Observable<GenericFile[]> {
        const url = `${environment.wsBaseUrl}/api/DocDownload/DocPicking/${encodeURIComponent(date)}/${encodeURIComponent(days)}`;
        return this._ws.getWithoutCache(url);
    }

    getControl(date: string, days: number): Observable<GenericFile[]> {
        const url = `${environment.wsBaseUrl}/api/DocDownload/DocControl/${encodeURIComponent(date)}/${encodeURIComponent(days)}`;
        return this._ws.getWithoutCache(url);
    }

    getSummary(date: string, days: number): Observable<GenericFile[]> {
        const url = `${environment.wsBaseUrl}/api/DocDownload/DocSummary/${encodeURIComponent(date)}/${encodeURIComponent(days)}`;
        return this._ws.getWithoutCache(url);
    }

    getCurrentPicking(docId: number): Observable<GenericFile[]> {
        const url = `${environment.wsBaseUrl}/api/DocDownload/CurrentDocPicking/${encodeURIComponent(docId)}`;
        return this._ws.getWithoutCache(url);
    }

    getCurrentControl(docId: number): Observable<GenericFile[]> {
        const url = `${environment.wsBaseUrl}/api/DocDownload/CurrentDocControl/${encodeURIComponent(docId)}`;
        return this._ws.getWithoutCache(url);
    }
}